import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { StyledSelect as Select } from '../../../components/Select';
import TextArea from '../../../components/TextArea';
import { Order } from '../../../helpers/Responses';
import Api from '../../../helpers/Api';
import Button from '../../../components/Button';
import { Label } from '../../../components/Typo';
import { AppContext } from '../../../context/AppContext';
import { toast } from 'react-toastify';
import "twin.macro"

const StatusField = styled.div` 

`;

const Status = styled.div<{ error?: boolean }>`
  color: ${p => p.error ? p.theme.danger : p.theme.primary};
  font-size: 1.2em;
  font-weight: bold;
`;

const StatusPaneContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding-bottom: 16px;

  ${Select}, ${StatusField} {
    flex: 1;
    margin-right: 16px;
  }
`;
StatusPaneContainer.displayName = 'StatusPaneContainer';

const Wrapper = styled.div`
  border-bottom: 1px solid #ccc;
  padding-bottom: 16px;
`;

interface Props {
  order: Order;
}

export default function OrderStatusPane(props: Props) {
  let { state } = useContext(AppContext);

  let { order } = props;

  let [statusLoading, setStatusLoading] = useState(false);
  let [statusSet, setStatusSet] = useState({
    status: order.status,
    payStatus: order.payStatus,
    delStatus: order.delStatus
  });

  useEffect(() => setStatusSet({
    status: order.status,
    payStatus: order.payStatus,
    delStatus: order.delStatus
  }), [order]);

  let [isDeliveryNoteOpen, setDeliveryNoteOpen] = useState(order.delNote || order.delStatus === 'delivered');
  let [deliveryNote, setDeliveryNote] = useState(order.delNote || '');

  async function handleUpdateStatus() {
    let msg = '';
    if (statusSet.status === 'completed') {
      if (statusSet.payStatus !== 'paid') msg = 'Unpaid order cannot be Closed';
      if (statusSet.delStatus !== 'delivered') msg = 'Undelivered order cannot be Closed';
    } else if (statusSet.status === 'rejected') {
      if (statusSet.delStatus === 'delivered') msg = 'Delivered order cannot be Rejected';
    }
    if (msg) return toast.error(msg);

    setStatusLoading(true);
    await Api.updateOrderStatus(order.id, { ...statusSet, delNote: deliveryNote });

    order.status = statusSet.status;
    order.payStatus = statusSet.payStatus;
    order.delStatus = statusSet.delStatus;
    order.delNote = deliveryNote;
    setStatusLoading(false);
  }

  function handleStatusChange(event: React.ChangeEvent<HTMLSelectElement>) {
    const name = event.target.name;
    const value = event.target.value;
    setStatusSet(statusSet => {
      let { status, delStatus, payStatus } = statusSet;
      if (name === 'status' && value === 'completed') {
        if (delStatus !== 'delivered') delStatus = 'delivered';
        if (payStatus !== 'paid') payStatus = 'paid';
      }
      const newStatusSet = { status, delStatus, payStatus, [name]: value }
      // if (order.delStatus !== 'delivered') {
        setDeliveryNoteOpen(newStatusSet.delStatus === 'delivered');
      // }
      return newStatusSet;
    })
  }

  function handleDeliveryNoteChanged(event: React.ChangeEvent<HTMLTextAreaElement>) {
    setDeliveryNote(event.target.value)
  }

  // TODO: repeated in order table
  const closed = ['completed', 'cancelled', 'rejected'].includes(order.status)
  if (!closed) {

    // once paid, dont allow go back
    const paymentOptions = (order.payStatus === 'paid') ? state.options.paidStatus : state.options.payStatus;

    return (
      <Wrapper>
        <StatusPaneContainer>
          <Select name="status" label="Order Status" options={state.options.orderStatus} value={statusSet.status} onChange={handleStatusChange} />
          <Select name="payStatus" label="Payment Status" options={paymentOptions} value={statusSet.payStatus} onChange={handleStatusChange} />
          <Select name="delStatus" label="Delivery Status" options={state.options.delStatus} value={statusSet.delStatus} onChange={handleStatusChange} />
          <Button onClick={handleUpdateStatus} loading={statusLoading}>Update</Button>
        </StatusPaneContainer>
        {isDeliveryNoteOpen && (
          <TextArea
            label="Delivery Note"
            placeholder='Enter delivery details like courier name, tracking number, link, etc.'
            rows={3}
            value={deliveryNote}
            onChange={handleDeliveryNoteChanged} />
        )}
      </Wrapper>
    )
  } else {
    return (
      <Wrapper>
        <StatusPaneContainer>
          <StatusField>
            <Label>Order Status</Label>
            <Status error={['cancelled', 'rejected'].includes(order.status)}>
              {state.map.orderStatus[order.status]}
            </Status>
          </StatusField>
          <StatusField>
            <Label>Payment Status</Label>
            <Status error={order.payStatus !== 'paid'}>
              {state.map.payStatus[order.payStatus]}
            </Status>
          </StatusField>
          <StatusField>
            <Label>Delivery Status</Label>
            <Status error={order.delStatus !== 'delivered'}>
              {state.map.delStatus[order.delStatus]}
            </Status>
          </StatusField>
        </StatusPaneContainer>
        {order.delNote && (
          <div>
            <Label>Delivery Note</Label>
            <p tw="text-gray-500 text-sm">{order.delNote}</p>
          </div>
        )}
      </Wrapper>
    )
  }
}